class StickyProductCard {
  constructor() {
    this.stickyCard = null;
    this.originalBuyButtons = null;
    this.isVisible = false;
    this.isMobile = false;
    
    this.init();
  }

  init() {
    this.checkMobile();
    
    if (!this.isProductPage()) {
      return;
    }

    this.originalBuyButtons = document.querySelector('buy-buttons');
    
    if (!this.originalBuyButtons) {
      return;
    }

    if (this.isMobile) {
      this.createStickyCard();
    }
    
    this.bindEvents();
  }

  isProductPage() {
    return document.body.classList.contains('template-product') || 
           window.location.pathname.includes('/products/');
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  createStickyCard() {
    const productData = this.getProductData();
    
    this.stickyCard = document.createElement('div');
    this.stickyCard.className = 'sticky-product-card';
    
    this.stickyCard.innerHTML = `
      <div class="sticky-product-card__content">
        <div class="sticky-product-card__image">
          ${this.getProductImage()}
        </div>
        <div class="sticky-product-card__info">
          <h3 class="sticky-product-card__title">${productData.title}</h3>
          <p class="sticky-product-card__subtitle">${productData.subtitle}</p>
          <p class="sticky-product-card__delivery">${productData.delivery}</p>
        </div>
        <button class="sticky-product-card__button" onclick="this.handleAddToCart()">
          <span>Add • </span>
          <span class="sticky-product-card__price">${productData.price}</span>
        </button>
      </div>
    `;

    document.body.appendChild(this.stickyCard);

    const button = this.stickyCard.querySelector('.sticky-product-card__button');
    button.addEventListener('click', () => this.handleAddToCart());
  }

  getProductData() {
    const titleElement = document.querySelector('.product-info .product-title') || 
                        document.querySelector('.product-title') ||
                        document.querySelector('h1.product-title') ||
                        document.querySelector('[data-testid="product-title"]') ||
                        document.querySelector('.product__title') ||
                        document.querySelector('h1');
    
    const priceElement = document.querySelector('.btn__price') || 
                        document.querySelector('.buy-button__cta .btn__price') ||
                        document.querySelector('.price') ||
                        document.querySelector('.product-price') ||
                        document.querySelector('.current-price') ||
                        document.querySelector('.money') ||
                        document.querySelector('[data-price]') ||
                        document.querySelector('.price-current') ||
                        document.querySelector('.product__price .money');
    
    const subscriptionElement = document.querySelector('[name="selling_plan"] option:checked') ||
                               document.querySelector('.delivery-item.active') ||
                               document.querySelector('.subscription-option.selected');

    let productTitle = 'Omega Max 3X - Triple Source Fish Oil For Dogs';
    if (titleElement) {
      productTitle = titleElement.textContent.trim();
    } else {
      const metaTitle = document.querySelector('meta[property="og:title"]');
      if (metaTitle) {
        productTitle = metaTitle.getAttribute('content');
      } else if (document.title) {
        productTitle = document.title.split('|')[0].trim();
      }
    }

    let productPrice = '$25.56';
    if (priceElement) {
      productPrice = priceElement.textContent.trim();
      productPrice = productPrice.replace(/[^\d.,\$€£¥]/g, '');
      if (!productPrice.includes('$') && !productPrice.includes('€') && !productPrice.includes('£')) {
        productPrice = '$' + productPrice;
      }
    } else {
      const variantScript = document.querySelector('script[type="application/json"]:not([class])');
      if (variantScript) {
        try {
          const variantData = JSON.parse(variantScript.textContent);
          if (variantData.price) {
            productPrice = '$' + (variantData.price / 100).toFixed(2);
          }
        } catch (e) {
          // Silent fail
        }
      }
    }

    return {
      title: productTitle,
      subtitle: subscriptionElement ? subscriptionElement.textContent.trim() : '1 Tub • Subscribe & Save •',
      delivery: 'Deliver Every 30 Days',
      price: productPrice
    };
  }

  getProductImage() {
    const mainImage = document.querySelector('.product_main-slider .main-slider_item.swiper-slide-active img') ||
                     document.querySelector('.product_main-slider .swiper-slide-active img') ||
                     document.querySelector('.product-main-image img') ||
                     document.querySelector('.product-image img') ||
                     document.querySelector('.product__image img') ||
                     document.querySelector('.product-gallery img') ||
                     document.querySelector('.product img') ||
                     document.querySelector('[data-product-image] img') ||
                     document.querySelector('.featured-image img');
    
    if (mainImage) {
      let imageSrc = mainImage.src;
      
      if (imageSrc.includes('cdn.shopify.com')) {
        imageSrc = imageSrc.replace(/_\d+x\d*\./, '_200x200.');
        if (!imageSrc.includes('_200x200.')) {
          imageSrc = imageSrc.replace(/\.(jpg|jpeg|png|webp)/, '_200x200.$1');
        }
      }
      
      return `<img src="${imageSrc}" alt="${mainImage.alt || 'Product'}" />`;
    }
    
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      return `<img src="${ogImage.getAttribute('content')}" alt="Product" />`;
    }
    
    return '<div style="background: #f0f0f0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #999;">📦</div>';
  }

  handleAddToCart() {
    const productForm = document.querySelector('.product-form') ||
                       document.querySelector('wp-product-form') ||
                       document.querySelector('[class*="product-form"]') ||
                       document.querySelector('buy-buttons');
    
    if (productForm) {
      productForm.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      productForm.style.transition = 'box-shadow 0.3s ease';
      productForm.style.boxShadow = '0 0 20px rgba(85, 58, 148, 0.3)';
      
      setTimeout(() => {
        productForm.style.boxShadow = '';
      }, 2000);
      
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  bindEvents() {
    let scrollTimeout;
    let resizeTimeout;
    
    window.addEventListener('scroll', () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(() => {
        this.handleScroll();
      }, 16);
    });

    window.addEventListener('resize', () => {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      
      resizeTimeout = setTimeout(() => {
        const wasMobile = this.isMobile;
        this.checkMobile();
        
        if (!wasMobile && this.isMobile) {
          if (!this.stickyCard && this.originalBuyButtons) {
            this.createStickyCard();
            setTimeout(() => this.handleScroll(), 100);
          }
        } else if (wasMobile && !this.isMobile) {
          if (this.isVisible) {
            this.hideStickyCard();
          }
        }
      }, 100);
    });
  }

  handleScroll() {
    if (!this.isMobile || !this.stickyCard || !this.originalBuyButtons) return;

    const buyButtonsRect = this.originalBuyButtons.getBoundingClientRect();
    const isOriginalVisible = buyButtonsRect.bottom > 0 && buyButtonsRect.top < window.innerHeight;

    const shouldShow = !isOriginalVisible;

    if (shouldShow && !this.isVisible) {
      this.showStickyCard();
    } else if (!shouldShow && this.isVisible) {
      this.hideStickyCard();
    }
  }

  showStickyCard() {
    if (!this.stickyCard) return;
    
    this.stickyCard.style.display = 'block';
    setTimeout(() => {
      this.stickyCard.classList.add('show');
    }, 10);
    
    this.isVisible = true;
  }

  hideStickyCard() {
    if (!this.stickyCard) return;
    
    this.stickyCard.classList.remove('show');
    setTimeout(() => {
      this.stickyCard.style.display = 'none';
    }, 300);
    
    this.isVisible = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new StickyProductCard();
});

if (document.readyState !== 'loading') {
  new StickyProductCard();
}
